export default __webpack_public_path__ + "static/media/mobilerequestcallback.0bf8792c.gif";